module.exports = __webpack_public_path__ + "Assets/Images/people/mike.jpg";